import { Widget } from '@/modules/ta/widget/models/Widget';

export class ChatGPTWidget extends Widget {
  constructor(model = {}) {
    super(model);
  }
}
